import { PayloadAction } from "@reduxjs/toolkit";
import { GroupsState } from "../../models/GroupsState";
import { GetGroupPayload } from "../../payload/GetGroup/GetGroupPayload";

const getGroupFetch = (state: GroupsState, action: PayloadAction<GetGroupPayload>) => {
    state.isLoading = true;
}

export default getGroupFetch;